import { createFileRoute, useNavigate } from '@tanstack/react-router';
import React, { useEffect } from 'react';
import PhoneCollection from '../components/PhoneCollection';
import { firebaseService } from '../services/firebaseService';

export const Route = createFileRoute('/auth')({
  component: Auth,
});

function Auth() {
  const navigate = useNavigate();

  // Check if already authenticated
  useEffect(() => {
    const checkAuth = async () => {
      try {
        const currentUser = await firebaseService.getCurrentUser();
        if (currentUser) {
          // Already authenticated, redirect to questionnaire
          navigate({ to: '/' });
        }
      } catch (error) {
        console.error('[Auth] Error checking auth:', error);
      }
    };

    checkAuth();
  }, [navigate]);

  const handlePhoneVerified = async (phoneNumber, email, idToken) => {
    console.log('[Auth] Phone verified, redirecting to questionnaire');
    
    // Navigate to questionnaire page
    navigate({ to: '/' });
  };

  return (
    <PhoneCollection onPhoneVerified={handlePhoneVerified} />
  );
}

